import {APPROVE_REQUEST_FAILURE} from "../../../enums/Employees/employees.types";

export const approveRequestFailureAction = (uid) => {
    return {
        type: APPROVE_REQUEST_FAILURE,
        payload: uid,
    };
};
